import { Link } from "@remix-run/react";
import { useTranslation } from "react-i18next";

import { Icon } from "~/components/atoms/Icons";
import Typo from "~/components/atoms/Typo";
import { ETypoColor } from "~/utilities/enums/Colors";
import { EIcon } from "~/utilities/enums/Icons";
import { ETypoTag, ETypoVariant } from "~/utilities/enums/Typo";

type TFilterSideBarOptionsMobileProps = {
  href: string;
};

const FilterSideBarOptionsMobile: React.FC<
  TFilterSideBarOptionsMobileProps
> = ({ href }) => {
  const { t } = useTranslation();

  return (
    <div className="hidden w-full flex-1 flex-row gap-2 rounded-full bg-background px-3 py-[4.5px] lg:flex">
      <Icon TypeIcon={EIcon.FilterIcon} width={16} height={16} />
      <Typo
        color={ETypoColor.TEXT}
        tag={ETypoTag.P}
        variant={ETypoVariant.HEADER_16}
        className="text-bold flex flex-1 items-center"
      >
        {t("filter")}
      </Typo>

      <Link
        to={href}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Typo
          tag={ETypoTag.P}
          variant={ETypoVariant.BODY_TITLE_16}
          color={ETypoColor.ERROR}
          className="cursor-pointer"
        >
          {t("clear_all")}
        </Typo>
      </Link>
    </div>
  );
};

FilterSideBarOptionsMobile.displayName = "FilterSideBarOptionsMobile";

export default FilterSideBarOptionsMobile;
